import { useQuery } from '@tanstack/react-query';
import { admin } from '@repletoryreach/sdk-api';

export function useLedger(opts: { org_id?: string; limit?: number } = {}) {
  return useQuery({
    queryKey: ['admin', 'ledger', opts.org_id ?? null, opts.limit ?? 100],
    queryFn: () => admin.listLedger({ org_id: opts.org_id, limit: opts.limit ?? 100 })
  });
}
